// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutTheAuthorsSSR-cls1_c2J","cls2":"AboutTheAuthorsSSR-cls2_Yk9 AboutTheAuthorsSSR-cls1_c2J"};